import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { PHONE_TEL, PHONE_DISPLAY, WHATSAPP_URL, EMAIL, CITY, MAP_LINK, HOURS } from "../../lib/site";

const Row = ({ icon: Icon, label, children, testId, href, external }) => {
  const body = (
    <>
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#D4AF37]/30 text-[#D4AF37] transition-[background-color,color] duration-300 group-hover:bg-[#D4AF37] group-hover:text-[#07040D]">
        <Icon className="h-4 w-4" />
      </span>
      <span className="min-w-0">
        <span className="block text-[11px] uppercase tracking-[0.25em] text-slate-400">{label}</span>
        <span className="mt-1 block break-words text-[15px] text-slate-100">{children}</span>
      </span>
    </>
  );
  const cls = "group flex items-center gap-4 border-b border-[#D4AF37]/10 py-5";
  return href ? (
    <a href={href} data-testid={testId} className={cls} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{body}</a>
  ) : (
    <div data-testid={testId} className={cls}>{body}</div>
  );
};

export const ContactDetails = ({ showHours = true }) => (
  <div data-testid="contact-details">
    <Row icon={Phone} label="Call" href={PHONE_TEL} testId="contact-phone-link">{PHONE_DISPLAY}</Row>
    <Row icon={WhatsAppIcon} label="WhatsApp" href={WHATSAPP_URL} external testId="contact-whatsapp-link">{PHONE_DISPLAY}</Row>
    <Row icon={Mail} label="Email" href={`mailto:${EMAIL}`} testId="contact-email-link">{EMAIL}</Row>
    <Row icon={MapPin} label="Studio" href={MAP_LINK} external testId="contact-address">{CITY}<span className="block text-sm text-[#D4AF37]">Get directions on Google Maps →</span></Row>
    {showHours && (
      <Row icon={Clock} label="Business hours" testId="contact-hours">
        {HOURS.map((h) => <span key={h.day} className="block">{h.day}: {h.time}</span>)}
      </Row>
    )}
  </div>
);
